import { Badge } from '@blimo/ui';
import { formatDateTime } from '@blimo/shared';

/**
 * Visibility of an announcement – only API flags are shown (`is_live`, `is_published`), the
 * time window is displayed as given (no date arithmetic in the frontend).
 * @param {{ announcement: { is_live?: boolean, is_published?: boolean } }} props
 */
export function AnnouncementStateBadge({ announcement }) {
  if (announcement.is_live) return <Badge variant="success">Live</Badge>;
  if (!announcement.is_published) return <Badge variant="neutral">Entwurf</Badge>;
  return <Badge variant="warning">Veröffentlicht, nicht sichtbar</Badge>;
}

/** "ab 01.10.2026 08:00 · bis 31.10.2026 18:00" @param {{ from?: string|null, to?: string|null }} props */
export function PublishWindow({ from, to }) {
  if (!from && !to) return <span className="text-muted-foreground">unbegrenzt</span>;
  return <span className="numeric">{[from ? `ab ${formatDateTime(from)}` : null, to ? `bis ${formatDateTime(to)}` : null].filter(Boolean).join(' · ')}</span>;
}
